import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EpsonLogoComponent } from '../shared/components/atoms/epson-logo/epson-logo.component';
import { FullPageLoadingComponent } from './full-page-loading/full-page-loading.component';

@NgModule({
  declarations: [FullPageLoadingComponent, EpsonLogoComponent],
  imports: [MatProgressSpinnerModule, CommonModule],
  exports: [FullPageLoadingComponent, EpsonLogoComponent],
})
/**
 * Full Page Loading component lives here
 */
export class FullPageLoadingModule {}
